import React, { useMemo, memo } from 'react';

import ReactEcharts from "echarts-for-react";
import echarts from 'echarts/lib/echarts';


const SearchChart = ({data}) => {

  const chartData = useMemo(() => {
    let rawData;
    if (!data) {
      rawData = []
    } else {
      rawData = data;
    }

    return rawData.map(item => [item.labels, Number(item.ref_freq_list)])

  },[data]);


  const options = useMemo(()=>{
    return {
      title: { 
          text: '종목검색 추이',
          left: 'left',
          textStyle: {
           fontSize: 14
          }
      },
      grid: {
          top: 50,
          right: 5,                      
          left: 5,
          height: 100
      },
      tooltip: {
          trigger: 'axis',
      },            
      xAxis: {
          type: 'category',
          splitLine: {
              show: false
          },
      },
      yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitNumber: 3, 
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
      },
      series: [
          {
              type: 'line',
              smooth: false,
              symbol: 'none',
              areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(100, 116, 214, 0.9)'                            
                  }, {
                      offset: 1,
                      color: 'rgba(255, 255, 255, 0)'
                  }])
              },
              data: chartData,
          }
      ],
      color: ['rgb(84, 112, 198)', 'rgb(145, 204, 117)', 'rgb(250, 200, 88)']
    }
  },[chartData])

  return (
    <ReactEcharts option={options} className="chart line" style={{height:''}}/>
  )
}

export default memo(SearchChart);